import { Signal, signal, WritableSignal } from '@angular/core';

export class RequestParams {
	private _params: Map<string, any> = new Map<string, any>();
	private readonly _paramsSignal: WritableSignal<Record<string, any>> = signal({});

	readonly params: Signal<Record<string, any>> = this._paramsSignal.asReadonly();

	constructor(params?: any) {
		if (params) this.updateParams(params);
	}

	getParams(keys?: Array<string>, excludeKeys: Array<string> = []): any {
		const params: Object = {};

		this._params.forEach((value: any, key: string) => {
			let param;
			if (Array.isArray(value)) {
				if (value.filter(item => item !== -1).length) param = value.join(',');
			} else {
				param = value;
			}
			if (param !== null && param !== undefined && param !== '') {
				if (!excludeKeys.includes(key)) {
					if (!keys) params[key] = param;
					else if (keys.includes(key)) params[key] = param;
				}
			}
		});

		return params;
	}

	getParam<T = any>(key: string): T {
		return this._params.get(key);
	}

	updateParams(params: Object, excludeKeys: Array<string> = []): void {
		for (let key in params) {
			if (excludeKeys.includes(key)) continue;
			if (
				params[key] === null ||
				params[key] === undefined ||
				params[key] === '' ||
				(Array.isArray(params[key]) && (!params[key].length))
			) {
				this._params.delete(key);
			} else {
				this._params.set(key, params[key]);
			}
		}
		this.emit();
	}

	clearParams(): void {
		this._params.clear();
		this.emit();
	}

	has(key: string): boolean {
		return this._params.has(key);
	}

	fromStorage(jsonParams: string, excludeKeys: Array<string> = []): void {
		this.updateParams(JSON.parse(jsonParams), excludeKeys);
	}

	toStorage(): string {
		return JSON.stringify(Object.fromEntries(this._params));
	}

	private emit(): void {
		this._paramsSignal.set(Object.fromEntries(this._params));
	}
}
